module.exports = __webpack_public_path__ + "img/4.cd6a91c2.png";